import { UtilsModule } from '@database/utils';
import { JSONFileImporterModule } from '@domain/json-file-importer';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CentralDatabaseModule } from '@database/central';
import { WorkspaceDatabaseModule } from '@database/workspace';
import { LoginPageModule } from '@pages/login';
import { LocalizationModule } from '@domain/localization';
import { TranslateModule } from '@ngx-translate/core';
import { SmartComponentsModule } from '@pages/smart-components';
import { JSONFileExporterModule } from '@domain/json-file-exporter';
import { LoggingModule } from '@shared/logging';
import { SharedModule } from '@shared';
import { TimeBombModule } from '@domain/time-bomb';
import { SortingModule } from '@domain/sorting';
import { SearchModule } from '@domain/search';
import { RegistrationModule } from '@domain/registration';
import { AuthenticationModule } from '@domain/authentication';
import { AuthenticationApiModule } from '@api/authentication';
import { SyncModule } from '@domain/sync';
import { ConnectionsModule } from '@domain/connections';
import { NoApiModePageModule } from '@pages/no-api-mode';
import { GeolocationModule } from '@domain/geolocation';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		UtilsModule,
		WorkspaceDatabaseModule,
		JSONFileImporterModule,
		JSONFileExporterModule,
		CentralDatabaseModule,
		LoginPageModule,
		NoApiModePageModule,
		LocalizationModule,
		TranslateModule,
		SmartComponentsModule,
		LoggingModule,
		SharedModule,
		TimeBombModule,
		GeolocationModule,
		SortingModule,
		SearchModule.forRoot(),
		RegistrationModule,
		AuthenticationModule,
		AuthenticationApiModule,
		SyncModule,
		ConnectionsModule
	],
	exports: [TranslateModule, SmartComponentsModule]
})
export class CoreModule {}
